/**
 * Email domains as the settings hold them (ADR 0122): trimmed, lower-cased,
 * without a leading "@". The same rule as the API's `normalize_domain`
 * (backend/app/domain/email_addresses.py), so a domain the screen accepts is
 * one the API saves; the API checks it again.
 */

// A hostname with at least one dot: labels of letters, digits and inner
// hyphens, ending in an alphabetic top-level label (punycode "xn--" included).
const DOMAIN =
  /^(?=.{1,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+(?:[a-z]{2,63}|xn--[a-z0-9-]{1,59})$/;
// Printable ASCII only. Checked before lower-casing: the Kelvin sign (U+212A)
// lower-cases to an ASCII "k".
const ASCII = /^[\x20-\x7e]*$/;

/** The domain, or null if it isn't one. */
export function normalizeDomain(raw: string): string | null {
  const text = raw.trim();
  if (!ASCII.test(text)) {
    return null;
  }
  const domain = text.toLowerCase().replace(/^@/, "");
  return DOMAIN.test(domain) ? domain : null;
}

/** The address in an email's "Needs client" group key (`email:pat@example.com`; ADR 0128). */
export function emailFromGroupKey(groupKey: string | null): string | null {
  if (groupKey?.startsWith("email:") !== true) {
    return null;
  }
  return groupKey.slice("email:".length) || null;
}

/** An address's domain, as the settings hold domains: "rep@Vendor.com" is "vendor.com". */
export function domainOf(address: string): string | null {
  const at = address.lastIndexOf("@");
  return at < 0 ? null : normalizeDomain(address.slice(at + 1));
}
